module.exports = __webpack_public_path__ + "media/src/public/img/logo_new_year-180c6af63cc2969216bda2058cd6917e.svg";